import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ImporterRun } from 'dashboard/models/importer-run';
import { saveImporterRun, saveImporterRuns } from 'dashboard/redux/actions/importer-runs';
import { ApiEndpoint, ApiModel, PaginationParams } from 'lib/interfaces/api';

export function loadImporterRunsList(
  currentPage: number | undefined,
  pageSize: number | undefined,
  importerId: string,
) {
  return async (dispatch: Dispatch) => {
    const params = {
      filter: {
        'importer-pipeline-id': importerId,
      },
      page: {
        number: currentPage,
        size: pageSize,
      },
    };

    const importerRunsResponse = await SessionClientDashboard.listResource<
      ImporterRun,
      PaginationParams
    >(ApiEndpoint.ImporterRun, params);

    const importerRuns = importerRunsResponse.data;
    const paginationParams = importerRunsResponse.meta;

    dispatch(saveImporterRuns(importerRuns, paginationParams));
  };
}

export const createImporterRun = (importerId: string) => {
  return async (dispatch: Dispatch) => {
    const response = await SessionClientDashboard.postResourceCreate<ImporterRun>(
      {
        type: ApiModel.ImporterRun,
      },
      {
        meta: { 'importer-pipeline-id': importerId },
      },
    );
    dispatch(saveImporterRun(response.data));
    return response;
  };
};
